import { render, staticRenderFns } from "./downloadDetail.vue?vue&type=template&id=54246ac3&scoped=true"
import script from "./downloadDetail.vue?vue&type=script&lang=js"
export * from "./downloadDetail.vue?vue&type=script&lang=js"
import style0 from "./downloadDetail.vue?vue&type=style&index=0&id=54246ac3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54246ac3",
  null
  
)

export default component.exports